var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.96549 0.834413C2.65307 0.521993 2.14654 0.521993 1.83412 0.834413C1.5217 1.14683 1.5217 1.65337 1.83412 1.96579L13.0341 13.1658C13.3465 13.4782 13.8531 13.4782 14.1655 13.1658C14.4779 12.8534 14.4779 12.3468 14.1655 12.0344L12.987 10.8559C14.217 9.87404 15.151 8.53699 15.6337 7.00008C14.6143 3.75441 11.5821 1.4001 7.99998 1.4001C6.70112 1.4001 5.47456 1.70963 4.39004 2.25896L2.96549 0.834413ZM6.37431 4.24323L7.58541 5.45434C7.71764 5.41897 7.85662 5.4001 8.00001 5.4001C8.88366 5.4001 9.60001 6.11645 9.60001 7.00011C9.60001 7.14349 9.58115 7.28247 9.54577 7.4147L10.7569 8.62581C11.0384 8.14937 11.2 7.59361 11.2 7.00011C11.2 5.23279 9.76732 3.8001 8.00001 3.8001C7.40651 3.8001 6.85074 3.96167 6.37431 4.24323Z",
    fill: "#47548C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96307 12.3575L7.79953 10.1939C6.19191 10.0946 4.90556 8.80821 4.80618 7.20059L1.86774 4.26214C1.20031 5.05789 0.684899 5.98546 0.366211 7.00014C1.38563 10.2458 4.41786 12.6001 7.99996 12.6001C8.67729 12.6001 9.33495 12.5159 9.96307 12.3575Z",
    fill: "#47548C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.bc5ecb5495755cb6814727073b16c6ec.svg";
export { ForwardRef as ReactComponent };